<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense dark elevation="0" color="primary">
                    <v-list-item-title>
                        <!-- <v-icon>mdi-eye-circle</v-icon> -->
                        <span>{{title}}</span>
                    </v-list-item-title>
                    <TitleButton
                        icon="mdi-floppy"
                        :name="work"
                        @click="onClickSave()" />
                    <TitleButton
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-form ref="form">
                        <v-row >
                            <v-col>
                                <DatePicker 
                                    label="作業日"
                                    v-model="editItems.date"
                                    dense />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <!-- <v-select v-if="places != null && places.length > 0" v-model="editItems.placeID" clearable label="場所" outlined :items="places" item-text="name" item-value="placeID"/> -->
                                <PlaceSelector v-if="places != null && places.length > 0" v-model="editItems.placeID" :places="places" :placeGroups="placeGroups"/>
                            </v-col>
                            <v-col>
                                <v-text-field 
                                    v-if="places == null || editItems.placeID == null" 
                                    v-model="editItems.placeName" 
                                    clearable 
                                    label="新しい場所" 
                                    item-text="text" 
                                    outlined 
                                    dense
                                    hint="登録されていない場所の時は、ここに入力します。" 
                                    persistent-hint />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import PlaceSelector from '@/components/seedling/items/SelectorPlace';
    import DatePicker from '@/components/tools/DatePicker';
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            PlaceSelector,
            DatePicker,
            TitleButton,
            Confirm
        },
        props: {
            places: {
                type: Array,
                default: null
            },
            placeGroups: {
                type: Array,
                default: null
            },
            seedlings: {
                type: Array,
                default: null
            }
        },
        computed: {
            title: function () {
                switch (this.mode) {
                    case 1: return "苗の定植"
                    case 2: return "苗の移動"
                    case 99: return "苗の移動"
                }
            },
            work: function () {
                switch (this.mode) {
                    case 1: return "定植"
                    case 2: return "移動"
                    case 99: return "廃棄"
                }
            }
        },
        data: function () {
            return {
                mode: 0,    // 1:定植,2:移動
                isView: false,
                editItems: {
                    date: this.df_currentDateTime("yyyy-MM-dd"),
                    placeID: null,
                    placeName: "",
                },
                completedListener: null,
                validatorMemoLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        methods: {
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {

                if (this.editItems.placeID == null && this.editItems.placeName.length == 0) {
                    this.$refs.confirm.show({
                        title: "入力エラー",
                        message: "場所を選択するか、新しい場所を入力して下さい。",
                        width: 400,
                        buttonYes: "入力に戻る",
                        buttonNo: "",
                    })
                    return
                }

                const self = this
                var title = ""
                var message = ""
                var buttonCaption = ""

                switch (this.mode) {
                    case 1:
                        title = "定植"
                        message = "苗を選択された場所に定植しますか？"
                        buttonCaption = "定植する"
                        break
                    case 2:
                        title = "移動"
                        message = "苗を選択された場所に移動しますか？"
                        buttonCaption = "移動する"
                        break
                    case 99:
                        title = "廃棄"
                        message = "苗を選択された場所に廃棄しますか？<br/>※廃棄された苗に対する作業は一切出来なくなります。"
                        buttonCaption = "廃棄する"
                        break
                }

                this.$refs.confirm.show({
                    title: title,
                    message: message,
                    buttonYes: buttonCaption,
                    buttonNo: "いいえ",
                    width: 600,
                    listenerYes: function () {
                        self.register()
                        return true
                    },
                })
            },
            /**
             * 登録処理
             */
            register: function () {
                console.log("register", this.editItems)

                const userUID = this.$store.getters["userUID"]
                const self = this

                // 場所が未選択で、かつ手入力されている時
                var newPlace = null
                if (this.editItems.placeID == null && this.editItems.placeName.length > 0) {
                    var newPlaceID = 1
                    if (this.places != null && this.places.length > 0) {
                        newPlaceID = Math.max(...this.places.map(m => m.placeID)) + 1
                    }
                    newPlace = {
                        // version: "1.0.0",
                        // placeID: newPlaceID,
                        // name: this.editItems.placeName,
                        // register: {
                        //     userUID: userUID,
                        //     dateTime: this.df_currentDateTime()
                        // },
                        // updater: {
                        //     userUID: "",
                        //     dateTime: ""
                        // }
                        version: "1.0.0",
                        placeID: newPlaceID,
                        cultivationType: null,
                        name: this.editItems.placeName,
                        details: {
                            area: 0,
                            variety: {
                                cropID: 1,
                                varietyID: 1
                            }
                        },
                        address: {
                            postalCode: "",
                            pref: "",
                            city: "",
                            address1: "",
                            address2: "",
                            areaID: ""
                        },
                        placeGroupID: "",
                        isDeleted: false,
                        streamingURLs: [],
                        image: null,
                        groupUserAuthorities: ["browse", "work", "environment"],
                        managementAgrichemical: {
                            enabled: false,
                            target: null,
                            dateTime: "",
                            startDate: {
                                month: 1,
                                day: 1
                            },
                        },
                        memo: "",
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                    this.editItems.placeID = newPlaceID
                }

                // 登録処理開始
                try {
                    var batch = db.batch()
                    // 苗
                    console.log(this.seedlings)
                    for (var i=0; i<this.seedlings.length; i++) {
                        const seedling = this.seedlings[i].body
                        console.log("update seedling", seedling)
                        seedling.updater.userUID = userUID
                        seedling.updater.dateTime = this.df_currentDateTime()
                        seedling.currentPlace = this.editItems.placeID
                        const history = {
                            type: null,
                            place: this.editItems.placeID,
                            date: this.editItems.date,
                            dateTime: this.df_currentDateTime(),
                            userUID: userUID
                        }
                        switch (this.mode) {
                            case 1:
                                history.type = 2
                                break;
                            case 2:
                                history.type = 3
                                break;
                            case 99:
                                history.type = 99
                                break;
                        }
                        seedling.placeHistories.push(history)
                        switch (this.mode) {
                            case 1:
                                seedling.state = 2
                                seedling.results.planting.userUID = userUID
                                seedling.results.planting.place = this.editItems.placeID,
                                seedling.results.planting.startDate = this.editItems.date
                                break;
                            case 99:
                                seedling.state = 99
                                break;
                        }
                        
                        batch.update(db.collection("users").doc(userUID).collection("seedlings").doc(seedling.seedlingID), seedling)
                    }

                    // 場所
                    if (newPlace != null) {
                        batch.set(db.collection("users").doc(userUID).collection("places").doc(""+newPlace.placeID), newPlace)
                        this.$store.commit(
                            "managementItems/addUserPlace",
                            {
                                userUID: userUID,
                                placeData: this.$store.getters["managementItems/loggedInUserPlaceData"], 
                                place: newPlace
                            }
                        )
                    }

                    // コミット
                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"苗の"+self.work+"を行いました。"})
                        if (newPlace != null) {
                            self.$emit("onRegisteredNewPlace", newPlace)
                        }
                        if (self.completedListener != null) {
                            self.completedListener()
                        }
                        self.isView = false
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"苗の"+self.work+"に失敗しました。", isError:true})
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"苗の"+self.work+"に失敗しました。", isError:true})
                }
            },
            show: function (mode, completedListener) {
                this.mode = mode
                this.completedListener = completedListener
                this.isView = true
            }
        }
    }
</script>
